import React from "react";
import InfoCard from "./InfoCard";
import arrow from "../../../../assets/icons/claimarrow.png";
import { Link } from "react-router-dom";

type MyType = {
  title?: string;
  subtitle?: string;
  topIcon?: string;
  infoCard?: any;
  customClass?: string;
  bottomSection?: boolean;
  bookSrc?: string;
  path?: string;
  parentClass?: string;
};
function WhatYouGainSection({
  title,
  subtitle,
  topIcon,
  infoCard,
  customClass,
  bottomSection,
  bookSrc,
  path,
  parentClass,
}: MyType = {}) {
  return (
    <>
      <section className=" container">
        <div className="guide-section">
          <div className="guide-title">
            <div className="container">
              <p className="guide-subtitle">
                <span>
                  <img src={topIcon} alt="" />
                </span>
                {subtitle}
              </p>
              <p className="vs-title">{title}</p>
              <div className={`${parentClass} row`}>
                {infoCard.map((card, idx) => (
                  <InfoCard
                    key={idx}
                    title={card.title}
                    desc={card.desc}
                    icon={card.icon}
                    customClass={customClass}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        {bottomSection ? (
          <div className="guide-bottom">
            <img src={bookSrc} alt="Guide Book" className="guide-bottom-img" />
            <Link to={path} className="guide-bottom-btn">
              CLAIM YOUR FREE COPY TODAY
              <span className="arrow">
                <img src={arrow} alt="" />
              </span>
            </Link>
          </div>
        ) : null}
      </section>
    </>
  );
}

export default WhatYouGainSection;
